import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import SiteNav from "components/Redesign/SiteNav.js";
import SiteFooter from "components/Redesign/SiteFooter.js";
import gartenImg from "assets/img/geschichte/geschichte-garten.jpg";
import bluteImg from "assets/img/geschichte/geschichte-bluete.jpg";
import mobiliarImg from "assets/img/geschichte/geschichte-mobiliar.jpg";
import corinnaImg from "assets/img/geschichte/geschichte-corinna.jpg";
import teamImg from "assets/img/geschichte/geschichte-team.jpg";

function Geschichte() {
  const { t } = useTranslation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="rd">
      <SiteNav />

      <section className="page-shell geschichte-page">
        <div className="wrap">
          <Link to="/ueber-uns" className="rd-back-link">← {t("ueberuns.Page title")}</Link>
          <div className="rd-section-no">{t("geschichte.Page label")}</div>
          <h1 className="page-shell-h1">{t("geschichte.Page title")}</h1>
          <p className="geschichte-subhead">{t("geschichte.Subheadline")}</p>

          <div className="geschichte-body">
            <p>{t("geschichte.Intro p1")}</p>
            <p>{t("geschichte.Intro p2")}</p>
          </div>

          <div className="geschichte-photo-duo">
            <div className="geschichte-photo">
              <img src={gartenImg} alt="Christoph bei der Bienenkontrolle im Tessiner Garten" loading="lazy" />
            </div>
            <div className="geschichte-photo">
              <img src={bluteImg} alt="Bienenstöcke unter blühenden Kirschbäumen im Tessin" loading="lazy" />
            </div>
          </div>

          <h2 className="geschichte-h2">{t("geschichte.Section2 heading")}</h2>
          <div className="geschichte-body">
            <p>{t("geschichte.Section2 p1")}</p>
            <p>{t("geschichte.Section2 p2")}</p>
            <p>{t("geschichte.Section2 p3")}</p>
          </div>

          <div className="geschichte-photo-trio">
            <div className="geschichte-photo">
              <img src={corinnaImg} alt="Corinna bei den Bienenstöcken im Tessin" loading="lazy" />
            </div>
            <div className="geschichte-photo">
              <img src={mobiliarImg} alt="Robert Bühler mit einer Bienenkiste" loading="lazy" />
            </div>
            <div className="geschichte-photo">
              <img src={teamImg} alt="Zwei Imker begutachten gemeinsam eine Bienenwabe" loading="lazy" />
            </div>
          </div>

          <div className="rd-shop-cta">
            <Link to="/unser-honig" className="cta-primary">
              {t("home.Hero CTA shop")} <span className="arr">→</span>
            </Link>
          </div>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}

export default Geschichte;
